module.exports = __webpack_public_path__ + "img/qu_pt.b11a8de.jpg";